// removed by extract-text-webpack-plugin
module.exports = {"root":"UpcomingEvents__root--270vv","event":"UpcomingEvents__event--3NjS6","headline":"UpcomingEvents__headline--G-3Yc","date":"UpcomingEvents__date--sFRoP","description":"UpcomingEvents__description--bFPQm","image":"UpcomingEvents__image--1Iegc","separator":"UpcomingEvents__separator--23hhm","bounce":"UpcomingEvents__bounce--1pj2V"};


//////////////////
// WEBPACK FOOTER
// ./src/events/components/UpcomingEvents/UpcomingEvents.css
// module id = ./src/events/components/UpcomingEvents/UpcomingEvents.css
// module chunks = 2